import { FC } from "react";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { MarketCardContainer } from "./Styled";

interface IMarketCard {
    address?: string;
    fop?: string;
}

export const MarketCard: FC<IMarketCard> = ({ address, fop }) => {
    return (
        <MarketCardContainer>
            {fop && <PrimaryText fontSize={16}>{fop}</PrimaryText>}
            {address && <SecondaryText>{address}</SecondaryText>}
        </MarketCardContainer>
    );
};
